'use client'
import Image from 'next/image'
import React from 'react'

import { Text } from '@/shared/components/typography'

interface RoadViewHeaderProps {
  setIsRoadViewOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const RoadViewHeader = ({ setIsRoadViewOpen }: RoadViewHeaderProps) => {
  const onCloseRoadView = () => {
    setIsRoadViewOpen(false)
  }

  return (
    <div className="relative flex h-[56px] w-full items-center bg-010">
      <div className="mx-auto h-[24px] w-full text-center">
        <Text level="text3" weight="regular" color="text090">
          로드뷰보기
        </Text>
      </div>
      <div className="absolute right-[16px] h-[24px] w-[24px] cursor-pointer" onClick={onCloseRoadView}>
        <Image
          src={'/icons/light_icn_close_24.svg'}
          width={18}
          height={18}
          alt={'닫기아이콘'}
          className="h-6 w-6 cursor-pointer"
        />
      </div>
    </div>
  )
}

export default RoadViewHeader
